import { Decorative } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import * as React from "react";
import styled, { css } from "styled-components";

import { TestimonialCarousel } from "@faire/retailer/components/TestimonialCarousel";

interface IProps {
  backgroundColor?: string;
}

export const QuoteSection: React.FC<IProps> = ({ backgroundColor }) => {
  return (
    <>
      <TopPadding $backgroundColor={backgroundColor} />
      <StyledTestimonialCarousel
        backgroundColor={backgroundColor}
        name="faire-direct-sign-up-landing-page-testimonials"
        hideStoryLink
        withRetailerCount
      />
      <BottomPadding $backgroundColor={backgroundColor} />
    </>
  );
};

const TopPadding = styled(Column)<{
  $backgroundColor?: string;
}>`
  height: ${getSpacing("3x")};
  ${responsiveMediaQueries.mobile} {
    height: ${getSpacing("8x")};
  }
  ${(props) =>
    props.$backgroundColor
      ? css`
          background-color: ${props.$backgroundColor};
        `
      : css`
          background-color: ${Decorative.tint.neutral};
        `}
`;

const BottomPadding = styled(Column)<{
  $backgroundColor?: string;
}>`
  height: 112px;
  ${(props) =>
    props.$backgroundColor
      ? css`
          background-color: ${props.$backgroundColor};
        `
      : css`
          background-color: ${Decorative.tint.neutral};
        `}
`;

const StyledTestimonialCarousel = styled(TestimonialCarousel)`
  height: 400px;
`;
